module.exports = __webpack_public_path__ + "static/media/flow-partner.60dc33d4.png";